import store from "@/store"

class Multicast {
  constructor() {
    this.multicast = true
    this.init = false
    this.player = "media"
  }
  async _init() {
    if (this.init) return true

    _$.vue.$on("mediaEnded", async () => {
      if (!__.media.getLoop()) return false
      if (__.platform.hasBackground()) __.platform.background(store.state.background.slides, __.media.getSource())
      else __.media.play(__.media.getSource(), true)
    })

    this.init = true
    return true
  }

  async start() {
    __.common._tvWindowSetSize()
    return true
  }
  async destroy() {
    this.stop()
    playmore[this.player].playerBehind()
    return true
  }
  async play(source, params) {
    const { csa, disableHW, vlc } = params
    if (typeof params === "undefined" && __.device.config("playmore_default_player.playmore_default_player") === "vlc") await this._switchPlayer(true)
    else await this._switchPlayer(vlc)

    if (document.getElementById("videoplane")) document.getElementById("videoplane").style.display = "none"
    const promise = await _$.progress.create()
    if (promise.isResolved) return false

    _$.vue.$once(["mediaPlaying", "mediaError"], e => {
      if (e.type === "mediaError") {
        promise.reject()
      } else promise.resolve()
    })

    /* Library Code */
    playmore[this.player].play(source, csa || null, disableHW ? false : true)
    /* Library Code */

    return promise.done
  }
  async stop() {
    if (!["playing"].includes(__.media.status)) return playmore[this.player].stop()

    let promise = await _$.progress.create()
    _$.vue.$once(["mediaStopped", "mediaError"], e => (e.type === "mediaError" ? promise.reject() : promise.resolve()))

    /* Library Code */
    playmore.vlc.stop()
    playmore.media.stop()
    /* Library Code */

    return promise.done
  }
  async pause() {
    let promise = await _$.progress.create()

    _$.vue.$once(["mediaPaused", "mediaError"], e => {
      e.type === "mediaError" ? promise.reject() : promise.resolve()
    })

    /* Library Code */
    playmore[this.player].pause()
    /* Library Code */

    return promise.done
  }
  async continue() {
    let promise = await _$.progress.create()

    _$.vue.$once(["mediaPlaying", "mediaError"], e => {
      e.type === "mediaError" ? promise.reject() : promise.resolve()
    })

    /* Library Code */
    playmore[this.player].play()
    /* Library Code */

    return promise.done
  }

  /* Control Helpers */
  async isSeekable() {
    return playmore[this.player].isSeekable()
  }
  async getDuration() {
    return playmore[this.player].getDuration()
  }
  async getPosition() {
    return playmore[this.player].getPosition()
  }
  async setPosition(second) {
    if (!playmore[this.player].isSeekable()) return false
    const res = playmore[this.player].setPosition(second)
    if (res) _$.handler.emit({ type: "mediaEvent", detail: { state: "playing" } })
    return res
  }

  /* Language and Subtitles Helpers */
  async getSubtitles() {
    /* Library Code */
    let subtitles = JSON.parse(playmore[this.player].getSubtitles()),
      hasCurrent = subtitles.find(subtitle => subtitle.current)
    /* Library Code */

    subtitles = subtitles.map((subtitle, index) => {
      const rawTitle = `${subtitle.title || ""}`.trim()
      const hasValidTitle = rawTitle && !/^unknown title$/i.test(rawTitle)
      const fallback = `${subtitle.description || `Subtitle ${index + 1}`}`.trim().toUpperCase()
      return { key: subtitle.pid, value: hasValidTitle ? rawTitle : fallback, selected: subtitle.current }
    })

    if (!subtitles.length) return false
    else subtitles.unshift({ key: "off", value: "None", selected: !hasCurrent })

    return subtitles
  }
  async setSubtitle(pid) {
    if (pid === "off") pid = -1
    else if (this.player === "vlc") pid = parseInt(pid, 10)
    return playmore[this.player].setSubtitle(pid)
  }
  async closeSubtitle() {
    return playmore[this.player].setSubtitle(-1)
  }

  async getLanguages() {
    /* Library Code */
    let audios = JSON.parse(playmore[this.player].getAudios())
    /* Library Code */

    audios = audios.map((audio, index) => {
      const rawTitle = `${audio.title || ""}`.trim()
      const hasValidTitle = rawTitle && !/^unknown title$/i.test(rawTitle)
      const fallback = `${audio.description || `Audio ${index + 1}`}`.trim().toUpperCase()
      return { key: audio.pid, value: hasValidTitle ? rawTitle : fallback, selected: audio.current }
    })

    if (audios.length <= 1) return false
    return audios
  }
  async setLanguage(pid) {
    if (!pid) pid = -1
    else if (this.player === "vlc") pid = parseInt(pid, 10)
    return playmore[this.player].setAudio(pid)
  }

  async _switchPlayer(useVLC) {
    const nextPlayer = useVLC ? "vlc" : "media"
    if (nextPlayer === this.player) return true

    if (nextPlayer === "vlc") playmore.media.stop()
    else playmore.vlc.stop()

    this.player = nextPlayer
  }
}

export default Multicast
